import React, {memo, useEffect, useMemo, useRef, useState} from "react";
import {connect} from "react-redux";
import moment from "moment";
import * as _ from "lodash";
import {Alert, Col, FormGroup, FormText, Input, Label, Row} from "reactstrap";
import { toLocalDateString, addToDate } from "../../../utils/DateUtils";
import BookingDropdown from "../BookingDropdown";
import {configs} from "../../../utils/configs";
import {getDiscountAmountByServiceId, getDiscountsForService} from "../../../api/discountsApi";
import {updateConfigBookingTicketModal} from "../../../actions/BaseComponentsActions";
import {APPOINTMENT_RELATION} from "../../../utils/common";

const TIME_SPLIT_VALUE = 15

const enumBookingArea = {
    FULL: 'FULL',
    HALF: 'SHARE'
}

const FRACTION_DIGITS = 2

const SERVICE_TIME_OFF_TYPES = {CUSTOM_DATE: 'CustomDate', REPEAT_DATE: 'RepeatDate'}
const SERVICE_TIME_OFF_SUB_TYPES = {FULL: 'Full', HALF: 'Half'}

const SportTimer = memo(function (props) {
    const {bookingDate, selectedService, selectedFacility, availableBookings, cartListBookings, shopTimeArr, holidays, timeOffs, serviceTimeOff, isLoadingBookingTicket, branchId, shopId, onClickAddBooking, isPickEditBooking, editBookingObject} = props

    const [startTimes, setStartTimes] = useState([])
    const [toggleStartTimes, setToggleStartTimes] = useState()
    const startTimeRef = useRef({selectedItem: undefined, isValid: true})

    const endTimeRef = useRef({selectedItem: undefined, isValid: true})
    const [endTimes, setEndTimes] = useState([])
    const [toggleEndTimes, setToggleEndTimes] = useState()

    const bookingAreaRef = useRef({selectedItem: undefined, isValid: true})
    const [bookingAreas, setBookingAreas] = useState([])
    const [toggleBookingAreas, setToggleBookingAreas] = useState()

    const [isCheckedFullDay, setIsCheckedFullDay] = useState()

    const [bookingObject, setBookingObject] = useState()

    const [discount, setDiscount] = useState(null)

    const fullDayRef = useRef()

    const buildTimeSlot = (startTime, endTime, availableDate) => {
        const formattedDate = moment(availableDate ? availableDate : bookingDate).format('YYYY-MM-DD')
        const timeObject = {time: startTime, status: 'InActive', formattedTime: moment(`01/01/2024 ${startTime}`).format('HH:mm')}

        let isClasWithTimeOffs = false, isClasWithHolidays = false, isClashWithBooking = false

        _.forEach(timeOffs, (obj) => {
            let dateA = moment(obj.facilityOffDate).format('YYYY-MM-DD');
            let dateB = `${formattedDate}`;

            if (selectedFacility.facilityId === obj.facilityId && dateA === dateB) {
                if (obj.type === 'Full' && obj.status === 'Active') {
                    isClasWithTimeOffs = true
                    return false;
                } else if (obj.type === 'Half' && obj.status === 'Active') {
                    if (isTimeSlotClash(startTime, endTime, obj.startTime , obj.endTime)) {
                        isClasWithTimeOffs = true
                        return false
                    }
                }
            }
        });

        if (isClasWithTimeOffs) {
            return timeObject
        }

        _.forEach(holidays, (obj) => {
            let dateA = moment(obj.holiday).format('YYYY-MM-DD');
            let dateB = `${formattedDate}`;

            if (dateA === dateB) {
                if (obj.type === 'Full') {
                    isClasWithHolidays = true
                    return false;
                } else if (obj.type === 'Half') {
                    if (isTimeSlotClash(startTime, endTime, obj.startTime , obj.endTime)) {
                        isClasWithHolidays = true
                        return false
                    }
                }
            }
        });

        _.forEach(serviceTimeOff, (obj) => {
            let dateA = '';
            let dateB = `${formattedDate}`;

            if (obj.serviceFacilityTimeOffType === SERVICE_TIME_OFF_TYPES.REPEAT_DATE && moment(formattedDate).format('dddd') === obj.repeatDay) {
                dateB = ''
            } else {
                dateA = moment(obj.serviceFacilityOffDate).format('YYYY-MM-DD')
            }

            if (dateA === dateB && selectedService.serviceId === obj.serviceId && selectedFacility.facilityId === obj.facilityId) {
                if (obj.holidayType === SERVICE_TIME_OFF_SUB_TYPES.FULL) {
                    isClasWithHolidays = true
                    return false;
                } else if (obj.holidayType === SERVICE_TIME_OFF_SUB_TYPES.HALF) {
                    if (isTimeSlotClash(startTime, endTime, obj.startTime , obj.endTime)) {
                        isClasWithHolidays = true
                        return false
                    }
                }
            }
        });

        if (isClasWithHolidays) {
            return timeObject
        }

        if (_.size(getCourts(startTime, endTime, availableDate)) > 0) {
            timeObject.status = 'Active'
        }

        return timeObject
    }

    /**
     * Generates an array of available end times for a service appointment.
     *
     * @param {string} startTime - The start time of the appointment in 'h:mm a' format (e.g., "10:30 AM").
     * @returns {Array} An array of objects containing available end times with status and formatted time details.
     */
    const createEndTimeArray = (startTime) => {
        // Format the booking date to 'YYYY-MM-DD' to ensure date consistency.
        const formattedBookingDate = moment(bookingDate).format('YYYY-MM-DD');

        // Calculate the service duration in minutes (hours converted to minutes + additional minutes).
        const serviceTime = selectedService.serviceHour * 60 + selectedService.serviceMinute;

        // Determine the first available end time by adding service duration to the start time.
        const firstTime = moment(`${formattedBookingDate} ${startTime}`, 'YYYY-MM-DD h:mm a').add(serviceTime, 'minutes');

        const firstTimeWithoutServiceTime = moment(`${formattedBookingDate} ${startTime}`, 'YYYY-MM-DD h:mm a');

        // Find the shop's closing time for the given booking day.
        const shopDay = _.find(shopTimeArr, { day: moment(bookingDate).format('dddd') }, null);

        // Find the shop's timings for the next day.
        const nextShopDay = _.find(shopTimeArr, { day: moment(bookingDate).add(1, 'days').format('dddd') }, null);

        // Define the shop's closing time for the current booking day.
        let closeTime = moment(`${formattedBookingDate} ${shopDay.closeTime}`, 'YYYY-MM-DD HH:mm');
        let isCrossDay = false

        // Handle the transition to the next day if the shop remains open past midnight.
        if (nextShopDay.status === 'Active') {
            // Define the shop's opening time for the next day.
            const nextDayOpenTime = moment(`${moment(formattedBookingDate).add(1, 'days').format('YYYY-MM-DD')} ${nextShopDay.openTime}`, 'YYYY-MM-DD HH:mm');

            // Check if the shop closes at 11:59 PM and reopens at 12:00 AM the next day.
            if (
                closeTime.hour() === 23 && closeTime.minute() === 59 &&
                nextDayOpenTime.hour() === 0 && nextDayOpenTime.minute() === 0 &&
                ((firstTime.hour() > 12 || (firstTime.hour() === 12 && firstTime.minute() > 0)) ||
                    (moment(formattedBookingDate).startOf('day').add(1, 'days').isSame(firstTime, 'day')))
            ) {
                isCrossDay = true
                // Determine the closing time for the next day.
                const nextDayCloseTime = moment(`${moment(formattedBookingDate).add(1, 'days').format('YYYY-MM-DD')} ${nextShopDay.closeTime}`, 'YYYY-MM-DD HH:mm');

                // If the shop is open past noon the next day, set closing time to 11:59 AM.
                if ((nextDayCloseTime.hour() * 60 + nextDayCloseTime.minute()) >= 720) {
                    closeTime = moment(`${moment(bookingDate).startOf('day').add(1, 'days').format('YYYY-MM-DD')} 11:59`, 'YYYY-MM-DD HH:mm');
                } else {
                    // Otherwise, set the closing time based on the next day's closing time.
                    closeTime = moment(bookingDate).startOf('day').add(1, 'days').add((nextDayCloseTime.hour() * 60 + nextDayCloseTime.minute()), 'minutes');
                }
            }
        }

        if (!isCrossDay && closeTime.hour() === 23 && closeTime.minute() === 59) {
            closeTime.add(1, 'minutes')
        }

        let isEndMidNight = false

        if (isCrossDay && firstTime.hour() === 0 && firstTime.minute() === 0) {
            firstTime.subtract(1, 'minutes')

            isEndMidNight = true
        }

        // Initialize iteration variables to generate the available time slots.
        let iterateDate = firstTime.clone();
        let canDo = true;
        let index = 2;

        // Initialize the end times array with the first calculated time.
        const endTimesArray = [{
            time: firstTime.format('h:mm a'), // 12-hour format with AM/PM
            status: 'Active',
            index: 1,
            formattedTime: firstTime.format('HH:mm'), // 24-hour format
            displayLabel: `${moment(firstTime.format('YYYY-MM-DD')).isSame(firstTimeWithoutServiceTime, 'day') ? firstTime.format('hh:mm A') : iterateDate.hour() === 0 && iterateDate.minute() === 0 ? '11:59 PM' : iterateDate.format('hh:mm A, DD MMM YYYY')}`
        }];

        if (isEndMidNight) {
            iterateDate.add(1, 'minutes')
        }

        // Generate subsequent time slots until the shop closes.
        while (canDo) {
            // Get the next potential start time for an appointment.
            const nextTimeStart = moment(`${formattedBookingDate} ${_.first(endTimesArray).time}`, 'YYYY-MM-DD h:mm a');

            // Add service duration to find the next available end time.
            iterateDate.add(serviceTime, 'minutes');

            // Stop if the next time exceeds the closing time.
            if (!iterateDate.isSameOrBefore(closeTime)) {
                canDo = false;
            } else {
                // Format start and end times for the new time slot.
                const buildStartTime = nextTimeStart.format('HH:mm');
                const buildEndTime = iterateDate.hour() === 0 && iterateDate.minute() === 0 ? '23:59' : iterateDate.format('HH:mm');
                const buildDate = iterateDate.hour() === 0 && iterateDate.minute() === 0 ? formattedBookingDate : iterateDate.format('YYYY-MM-DD');

                // Create a new time slot object.
                const nextTimeObj = buildTimeSlot(buildStartTime, buildEndTime, buildDate);

                // Only add to the array if the time slot is active.
                if (nextTimeObj.status === 'Active') {
                    endTimesArray.push({
                        ...nextTimeObj,
                        time: iterateDate.format('h:mm a'),
                        index: index,
                        formattedTime: iterateDate.format('HH:mm'),
                        displayLabel: `${moment(formattedBookingDate).isSame(iterateDate, 'day') ? iterateDate.format('hh:mm A') : iterateDate.hour() === 0 && iterateDate.minute() === 0 ? '11:59 PM' : iterateDate.format('hh:mm A, DD MMM YYYY')}`
                    });
                    index++;
                } else {
                    canDo = false;
                }
            }
        }

        return endTimesArray;
    };

    const onsSelectStartTime = () => {
        const startTime = startTimeRef.current.selectedItem.time
        const endTimesList = createEndTimeArray(startTime)

        endTimeRef.current.selectedItem = endTimesList[0]
        const endTime = endTimeRef.current.selectedItem.time

        const courts = getCourts(startTime, endTime)

        bookingAreaRef.current.selectedItem = courts[0]
        setBookingAreas(courts)
        setToggleBookingAreas(!toggleBookingAreas)
        setToggleEndTimes(!toggleEndTimes)
        setEndTimes(endTimesList)
    }

    const onSelectEndTIme = () => {
        const startTime = startTimeRef.current.selectedItem.time
        const endTime = endTimeRef.current.selectedItem.time

        const formattedStartTime = moment(`${moment(bookingDate).format('YYYY-MM-DD')} ${startTime}`, `YYYY-MM-DD ${moment(startTime, 'HH:mm', true).isValid() ? 'HH:mm' : 'HH:mm a'}`)
        const formattedEndTime = moment(`${moment(bookingDate).format('YYYY-MM-DD')} ${endTime}`, `YYYY-MM-DD ${moment(endTime, 'HH:mm', true).isValid() ? 'HH:mm' : 'HH:mm a'}`)

        let availableDate = bookingDate

        if ((formattedStartTime.hour() * 60 + formattedStartTime.minute()) > (formattedEndTime.hour() * 60 + formattedEndTime.minute())) {
            availableDate = moment(`${moment(bookingDate).format('YYYY-MM-DD')}`).startOf('day').add(1, 'days').format('YYYY-MM-DD')
        }

        const courts = getCourts(startTime, endTime, availableDate)

        bookingAreaRef.current.selectedItem = courts[0]
        setBookingAreas(courts)
        setToggleBookingAreas(!toggleBookingAreas)
    }

    const getCourts = (startTime, endTime, availableDate) => {
        // Full court booked scenario
        if (_.size(availableBookings) === 1 && availableBookings[0].isFullDay) {
            return [];
        }
        
        const formattedCheckingDate = availableDate ? moment(availableDate).format('YYYY-MM-DD') : moment(bookingDate).format('YYYY-MM-DD')
        const formattedBookingDate = moment(bookingDate).format('YYYY-MM-DD')

        // Initialize an empty array to store processed booking objects
        const spreadCartListBookings = [];

        // Iterate over each object in cartListBookings
        _.forEach(cartListBookings, obj => {
            // Check if the booking type is 'COMBINE' (a specific type of appointment relation)
            if (obj.bookingType === APPOINTMENT_RELATION.COMBINE) {
                // Add a modified copy of the booking object where:
                // - The appointment date is moved to the next day.
                // - The start time is set to '00:00' (midnight).
                spreadCartListBookings.push({
                    ...obj,
                    appointmentDate: moment(obj.appointmentDate).startOf('day').add(1, 'days').format('YYYY-MM-DD'),
                    startTime: '00:00'
                });

                // Add another modified copy where:
                // - The end time is set to '23:59' (end of the day).
                spreadCartListBookings.push({
                    ...obj,
                    endTime: '23:59'
                });
            } else {
                // If not a 'COMBINE' booking, add the object as it is.
                spreadCartListBookings.push({ ...obj });
            }
        });

        const currentBookings = filterBookingByDateTime([...spreadCartListBookings, ...availableBookings], selectedFacility.facilityId, formattedBookingDate, formattedCheckingDate, startTime, endTime)

        const areas = []

        if (selectedFacility.partialSupport && selectedService.isPartialSupport) {
            const partitionCount = selectedFacility.portionCount

            if (_.size(currentBookings) === 0) {
                areas.push(creatBookingAreaObject(enumBookingArea.FULL, null, _.uniqueId()))
                for (let i = 0; i < partitionCount; i++) {
                    areas.push(creatBookingAreaObject(enumBookingArea.HALF, i + 1, _.uniqueId()))
                }
            } else {
                if (!(_.find(currentBookings, {courtName: enumBookingArea.FULL})) && _.size(currentBookings) === _.size(_.filter(currentBookings, {facilityPortionCount: selectedFacility.portionCount}))) {
                    const groupedBookings = _.groupBy(currentBookings, 'startTime')
                    const courtNames = []
                    let sortingBookings = []
                    let availableCourtCount = 0

                    _.forEach(groupedBookings, (value, key) => {
                        groupedBookings[key] = value.sort((a, b) => moment(`01/01/2024 ${a.endTime}`).isBefore(moment(`01/01/2024 ${b.endTime}`)) ? -1 : 1)
                    })
                    _.forEach(Object.keys(groupedBookings).sort((a, b) => moment(`01/01/2024 ${a}`).isBefore(moment(`01/01/2024 ${b}`)) ? -1 : 1), (key) => {
                        sortingBookings = [...sortingBookings, ...groupedBookings[key]]
                    })
                    _.forEach(sortingBookings, (obj, index) => {
                        if (sortingBookings[index + 1]) {
                            if (!(moment(`01/01/2024 ${sortingBookings[index + 1].startTime}`).isSameOrAfter(moment(`01/01/2024 ${obj.endTime}`)))) {
                                courtNames.push(obj.courtName)
                                availableCourtCount++
                            }
                        } else {
                            courtNames.push(obj.courtName)
                            availableCourtCount++
                            return false
                        }
                    })

                    if ((partitionCount - availableCourtCount) >= 1) {
                        for (let i = 0; i < (partitionCount - availableCourtCount); i++) {
                            let number = i + 1

                            if (courtNames.indexOf(`${enumBookingArea.HALF}_${number}`) === -1) {
                                areas.push(creatBookingAreaObject(enumBookingArea.HALF, i + 1, _.uniqueId()))
                            } else {
                                let isTrue = true

                                while (isTrue) {
                                    if (courtNames.indexOf(`${enumBookingArea.HALF}_${number + 1}`) === -1) {
                                        isTrue = false
                                        courtNames.push(`${enumBookingArea.HALF}_${number + 1}`)
                                        areas.push(creatBookingAreaObject(enumBookingArea.HALF, number + 1, _.uniqueId()))
                                    }

                                    number++
                                }
                            }
                        }
                    }
                }
            }
        } else if (_.size(currentBookings) === 0) {
            areas.push(creatBookingAreaObject(enumBookingArea.FULL))
        }

        return areas
    }

    const onCreateBooking = async (halfCourtName) => {
        if (halfCourtName) {
            let otherPriceAmount = 0
            const booking = {
                uniqueId: _.uniqueId('booking_item_'),
                branchId,
                shopId: shopId,
                isWalking: "true",
                guestCustomer: false,
                // email: this.state.email,
                employeeId: null,
                facilityId: selectedFacility.facilityId,
                serviceId: selectedService.serviceId,
                // firstName: this.state.firstName,
                // lastName: this.state.lastName,
                // mobileNo: this.state.mobileNo,
                appointmentDate: moment(bookingDate).format('YYYY-MM-DD'),
                specialNote: '',
                halfCourtName: (fullDayRef.current && fullDayRef.current.checked) ? enumBookingArea.FULL : halfCourtName,
                courtName: (fullDayRef.current && fullDayRef.current.checked) ? enumBookingArea.FULL : halfCourtName,
                isPartial: (fullDayRef.current && fullDayRef.current.checked) ? false : halfCourtName !== enumBookingArea.FULL,
                isFullDay: fullDayRef.current ? fullDayRef.current.checked : false,
                startTime: startTimeRef.current.selectedItem.formattedTime,
                endTime: endTimeRef.current.selectedItem.formattedTime,
                customizedSlots: endTimeRef.current.selectedItem.index,
                amount: 0,
                additionalPricingListIds: [],
                guests: [],
                facilityPortionCount: selectedFacility.portionCount,
                bookedPortionCount: 1,
                facilityPortionPrice: Number(`${_.get(_.find(selectedFacility.portionPriceDTORsList, {serviceId: selectedService.serviceId, status: "Active"}), 'portionPrice', 0)}`) > 0 ? Number(`${_.get(_.find(selectedFacility.portionPriceDTORsList, {serviceId: selectedService.serviceId, status: "Active"}), 'portionPrice', 0)}`) : selectedService.servicePartialPrice ? selectedService.servicePartialPrice : selectedService.serviceFullPrice,
                discountMode: null,
                discountValue: null,
                netAmount: null
            }

            if (fullDayRef.current && fullDayRef.current.checked) {
                const shopDay = _.find(shopTimeArr, {day: moment(bookingDate).format('dddd')}, null)

                if (shopDay) {
                    booking.startTime = shopDay.openTime
                    let [hours, minutes] = shopDay.closeTime.split(":").slice(0, 2); // convert hh:mm:ss to hh:mm
                    booking.endTime = `${hours}:${minutes}`
                }

                const duration = moment(`01/01/2024 ${booking.endTime}`).diff(moment(`01/01/2024 ${booking.startTime}`), 'minutes');
                const serviceTime = (selectedService.serviceHour * 60) + selectedService.serviceMinute;

                booking.amount = selectedService.fullDayPrice > 0 ? Number(`${selectedService.fullDayPrice}`) : Number(`${((Number(selectedService.serviceFullPrice) / serviceTime) * Number(duration))}`)
            } else {
                booking.amount = booking.isPartial && selectedService.servicePartialPrice > 0 ? booking.facilityPortionPrice * booking.customizedSlots : booking.customizedSlots * selectedService.serviceFullPrice
            }

            booking.amount = Number(Number.parseFloat(`${booking.amount}`).toFixed(FRACTION_DIGITS))

            let otherPricingList = getOtherPricing(_.get(selectedService, 'isAdditionalPricingSupport', false), _.get(selectedService, 'additionalPricingList', []), booking.appointmentDate, booking.startTime, booking.endTime, booking.isFullDay)

            if (_.size(otherPricingList) > 0) {
                const updatedPriceList = _.map(otherPricingList, (obj) => {
                    // const charging = Number(booking.isFullDay ? obj.meta.fullPrice : (obj.otherTimeMinutes * (((booking.isPartial && obj.meta.partialPrice) ? obj.meta.partialPrice : obj.meta.fullPrice) / obj.serviceChargeMinutes)))
                    let charging = Number(booking.isFullDay ? obj.meta.fullPrice : (obj.otherTimeMinutes * ((booking.isPartial ? (_.isNaN(obj.meta.partialPrice) ? 0 : obj.meta.partialPrice) : (_.isNaN(obj.meta.fullPrice) ? 0 : obj.meta.fullPrice)) / obj.serviceChargeMinutes)))

                    charging = Number(Number.parseFloat(`${charging}`).toFixed(FRACTION_DIGITS))

                    otherPriceAmount = otherPriceAmount + charging

                    return {...obj, charging}
                });

                booking.amount = booking.amount + otherPriceAmount;
                booking.additionalPricingListIds = _.map(otherPricingList, obj => obj.meta.id)
                otherPricingList = updatedPriceList
            }

            // booking.amount = Number.parseFloat(`${booking.amount}`).toFixed(FRACTION_DIGITS)
            booking.otherPricingList = otherPricingList
            booking.otherPriceAmount = otherPriceAmount

            booking.discountMode = null
            booking.discountValue = null
            booking.netAmount = booking.amount
            booking.discountValueFromAPI = null
            booking.discountModeFromAPI = null
            booking.discountnetAmountFromAPI = null

            const formattedStartTime = moment(`${moment(bookingDate).format('YYYY-MM-DD')} ${booking.startTime}`, 'YYYY-MM-DD HH:mm')
            const formattedEndTime = moment(`${moment(bookingDate).format('YYYY-MM-DD')} ${booking.endTime}`, 'YYYY-MM-DD HH:mm')

            booking.isCombineBooking = false;

            if (formattedEndTime.hour() === 0 && formattedEndTime.minute() === 0) {
                // Case 1: If the end time is exactly at 00:00 (midnight),
                // it means the booking is carried over to the next day.
                // Mark it as a 'SEPARATE' type and set endTime to '23:59' for clarity.
                booking.bookingType = APPOINTMENT_RELATION.SEPARATE;
                booking.endTime = '23:59';
            } else if ((formattedStartTime.hour() * 60 + formattedStartTime.minute()) >
                (formattedEndTime.hour() * 60 + formattedEndTime.minute())) {
                // Case 2: If the start time (converted to total minutes) is greater than the end time,
                // it implies the booking crosses over midnight.
                // Mark it as a 'COMBINE' type, meaning it spans across two days.
                booking.bookingType = APPOINTMENT_RELATION.COMBINE;
                booking.isCombineBooking = true;
            } else {
                // Case 3: Default case where start time is before end time within the same day.
                // Mark it as a 'SEPARATE' type.
                booking.bookingType = APPOINTMENT_RELATION.SEPARATE;
            }

            if (configs.discount.isEnable) {
                props.updateConfigBookingTicketModal({isLoading: true})

                // check for discounts
                const appointmentStartDateTime = toLocalDateString(booking.appointmentDate, booking.startTime); 
                let appointmentEndDateTime = toLocalDateString(booking.appointmentDate, booking.endTime);

                if(booking.isCombineBooking){
                    appointmentEndDateTime = addToDate(appointmentEndDateTime, 1, 'days');
                }

                const request = {
                        appointmentDateTime: appointmentStartDateTime, // TODO: deprecate
                        startAt: appointmentStartDateTime,
                        endAt: appointmentEndDateTime,
                        amount: Number(booking.amount)
                    }
                const checkForDiscounts = await getDiscountsForService(shopId, selectedService.serviceId, [request])

                props.updateConfigBookingTicketModal({isLoading: false})

                if(_.size(checkForDiscounts?.data) > 0 && checkForDiscounts.data[0]?.discountType) {
                    const _discount = checkForDiscounts.data[0]
                    setDiscount(_discount)

                    booking.discountMode = _discount.discountType
                    booking.discountValue = Number(booking.amount) - Number(_discount.amount) + "/="
                    booking.netAmount =  Number(_discount.amount)
                    booking.discountValueFromAPI = Number(booking.amount) - Number(_discount.amount) + "/="
                    booking.discountModeFromAPI = _discount.discountType
                    booking.discountnetAmountFromAPI = Number(_discount.amount)
                }else{
                    setDiscount(null)
                }
            }

            if (_.isFunction(onClickAddBooking)) {
                onClickAddBooking(booking)
            }

            setBookingObject(booking)
        } else {
            setBookingObject(undefined)
            onClickAddBooking(undefined)
        }
    }

    useEffect(() => {
        if (moment(bookingDate).isValid() && selectedService && selectedFacility) {
            if (isLoadingBookingTicket) {
                startTimeRef.current.selectedItem = undefined
                endTimeRef.current.selectedItem = undefined
                bookingAreaRef.current.selectedItem = undefined
                setStartTimes([])
                setEndTimes([])
                setBookingAreas([])
                setIsCheckedFullDay(false)
            } else {
                const serviceTime = selectedService.serviceHour * 60 + selectedService.serviceMinute
                let startTimeArray = _.map(createStartTimeArray(bookingDate, shopTimeArr, serviceTime), time => {
                    const serviceStartTime = moment(`${moment(bookingDate).format('YYYY-MM-DD')} ${time}`, 'YYYY-MM-DD h:mm a')
                    const serviceEndTime = serviceStartTime.clone().add(serviceTime, 'minutes')
                    const clashDate = serviceEndTime.format('YYYY-MM-DD')


                    return buildTimeSlot(serviceStartTime.format('HH:mm'), serviceEndTime.format('HH:mm'), clashDate)
                })

                startTimeArray = _.map(startTimeArray, item => {
                    return {...item, time: moment(item.time, 'HH:mm').format('h:mm a'), displayLabel: moment(item.time, 'HH:mm').format('h:mm A')}
                })
                startTimeRef.current.selectedItem = _.find(startTimeArray, {status: 'Active'}) ? {..._.find(startTimeArray, {status: 'Active'})} : undefined

                if (startTimeRef.current.selectedItem) {
                    onsSelectStartTime()
                    setToggleStartTimes(!toggleStartTimes)
                    setStartTimes(startTimeArray)
                } else {
                    endTimeRef.current.selectedItem = undefined
                    setEndTimes([])
                    setStartTimes([])
                    setBookingAreas([])
                    setIsCheckedFullDay(false)
                }
            }
        }
    }, [bookingDate, selectedService, selectedFacility, availableBookings, cartListBookings.length])

    useEffect(() => {
        if (isPickEditBooking && !_.isEmpty(editBookingObject)) {
            const serviceTime = selectedService.serviceHour * 60 + selectedService.serviceMinute
            let startTimeArray = _.map(createStartTimeArray(bookingDate, shopTimeArr, serviceTime), time => buildTimeSlot(moment(time, 'h:mm a').format('HH:mm'), moment(time, 'h:mm a').add(serviceTime, 'minutes').format('HH:mm')))

            startTimeArray = _.map(startTimeArray, item => {
                return {...item, time: moment(item.time, 'HH:mm').format('h:mm a'), displayLabel: moment(item.time, 'HH:mm').format('h:mm A')}
            })

            const bookingStartTime = _.get(editBookingObject, 'primaryAppointment.startTime', false) ? _.get(editBookingObject, 'primaryAppointment.startTime', '00:00') : editBookingObject.startTime
            const bookingEndTime = _.get(editBookingObject, 'secondaryAppointment.endTime', false) ? _.get(editBookingObject, 'secondaryAppointment.endTime', '00:00') : editBookingObject.endTime

            const selectedStartTime = _.find(startTimeArray, {formattedTime: bookingStartTime, status: 'Active'})
            if (selectedStartTime) {
                const endTimesList = createEndTimeArray(selectedStartTime.time)
                let endTime = _.get(endTimesList, '[0]', null)

                if (editBookingObject.isFullDay) {
                    endTime = _.last(endTimesList)
                } else {
                    const end = _.find(endTimesList, {formattedTime: bookingEndTime})

                    if (end) {
                        endTime = end
                    }
                }

                startTimeRef.current.selectedItem = selectedStartTime
                endTimeRef.current.selectedItem = endTime

                if (endTime) {
                    const formattedBookingDate = _.get(editBookingObject, 'secondaryAppointment.endTime', false) ? moment(new Date(editBookingObject.appointmentDate)).startOf('day').add(1, 'days').format('YYYY-MM-DD') : moment(new Date(editBookingObject.appointmentDate)).format('YYYY-MM-DD')
                    const courts = getCourts(selectedStartTime.time, endTime.time, formattedBookingDate)
                    const selectedCourt = _.find(courts, {halfCourtName: editBookingObject.courtName})

                    bookingAreaRef.current.selectedItem = selectedCourt ? selectedCourt: courts[0]
                    setStartTimes(startTimeArray)
                    setEndTimes(endTimesList)
                    setBookingAreas(courts)

                    if (editBookingObject.isFullDay) {
                        setIsCheckedFullDay(true)
                        onCreateBooking(bookingAreaRef.current.selectedItem.halfCourtName)
                        fullDayRef.current.checked = true
                    } else {
                        setToggleStartTimes(!toggleStartTimes)
                        setToggleEndTimes(!toggleEndTimes)
                        setToggleBookingAreas(!toggleBookingAreas)
                    }
                } else {
                    endTimeRef.current.selectedItem = undefined
                    setEndTimes([])
                    setStartTimes([])
                    setBookingAreas([])
                    setIsCheckedFullDay(false)
                }
            } else {
                startTimeRef.current.selectedItem = _.find(startTimeArray, {status: 'Active'}) ? {..._.find(startTimeArray, {status: 'Active'})} : undefined

                if (startTimeRef.current.selectedItem) {
                    onsSelectStartTime()
                    setToggleStartTimes(!toggleStartTimes)
                    setStartTimes(startTimeArray)
                } else {
                    endTimeRef.current.selectedItem = undefined
                    setEndTimes([])
                    setStartTimes([])
                    setBookingAreas([])
                    setIsCheckedFullDay(false)
                }
            }
        }
    }, [isPickEditBooking]);

    const hasFullDayBooking = useMemo(() => {
        if (_.size(startTimes) > 0 && bookingDate && selectedService && selectedFacility) {
            const startTime = _.first(startTimes).time
            const endTime = _.last(startTimes).time
            const timeSlot = buildTimeSlot(startTime, endTime)

            return timeSlot.status === 'Active' && _.find(getCourts(startTime, endTime), {halfCourtName: enumBookingArea.FULL})
        }

        return false
    }, [[startTimes, bookingDate, selectedService, selectedFacility, availableBookings, cartListBookings]])

    useEffect(() => {
        if (_.size(startTimes) > 0) {
            if (!isLoadingBookingTicket) {
                onCreateBooking(bookingAreaRef.current?.selectedItem?.halfCourtName)
            }
        } else {
            onCreateBooking()
        }
    }, [toggleBookingAreas]);

    return (<>
        {hasFullDayBooking && !isLoadingBookingTicket && <Row>
            <Col>
                <FormGroup className='pt-4 pb-4 px-4 border-top border-bottom d-flex justify-content-between align-items-center'>
                    <div>
                        <Input
                            onChange={ e => {
                            setIsCheckedFullDay(e.target.checked)
                            onCreateBooking(bookingAreaRef.current.selectedItem.halfCourtName)}}
                            checked={isCheckedFullDay}
                            innerRef={fullDayRef} type="checkbox" name="is_full_day" id="booking_ticket_full_day" />
                        <Label check for="full_day">Full Day Booking</Label>
                    </div>
                </FormGroup>
            </Col>
        </Row>}

        {!isCheckedFullDay && <Row>
                <Col md={4} sm={6} xs={6}>
                    <BookingDropdown
                        id='booking-ticket-start-times'
                        disables={isCheckedFullDay}
                        ref={startTimeRef}
                        label='Start Time'
                        displayLabel='displayLabel'
                        validateText='Please Select a Time'
                        toggleValidate={toggleStartTimes}
                        onSelectItem={() => onsSelectStartTime()}
                        required={true}
                        itemList={startTimes}/>
                </Col>
                <Col md={4} sm={6} xs={6}>
                    <BookingDropdown
                        id='booking-ticket-end-times'
                        ref={endTimeRef}
                        toggleValidate={toggleEndTimes}
                        label='End Time'
                        displayLabel='displayLabel'
                        validateText='Please Select a Time'
                        onSelectItem={() => onSelectEndTIme()}
                        required={true}
                        itemList={endTimes}/>
                </Col>
                <Col md={4}>
                    <BookingDropdown
                        id='booking-ticket-facilty-court-dropdown'
                        ref={bookingAreaRef}
                        toggleValidate={toggleBookingAreas}
                        label='Court'
                        displayLabel='displayBookingArea'
                        validateText='Please Select a Court'
                        onSelectItem={(item) => {
                            onCreateBooking(item.halfCourtName)
                        }}
                        required={true}
                        itemList={bookingAreas}/>
                </Col>
            </Row>}
        {!isLoadingBookingTicket && _.size(startTimes) > 0 && bookingObject && <Row>
            <Col>
                <p>
                    <span className='d-block'>{bookingObject.otherPriceAmount > 0 ? `Fixed Amount ${configs.currencyPrefix}: ${Number.parseFloat(`${bookingObject.amount - bookingObject.otherPriceAmount}`).toFixed(FRACTION_DIGITS)}` : `Amount (${configs.currencyPrefix}): ${bookingObject.amount}`}</span>
                    {bookingObject.otherPriceAmount > 0 && <>
                        {_.map(bookingObject.otherPricingList, (object, index) => {
                            return <>
                                <span className="pt-1 d-block">Additional Charging {index + 1}: {configs.currencyPrefix}{Number.parseFloat(object.charging).toFixed(FRACTION_DIGITS)}</span>
                                <span className="text-muted small d-block">({object.meta.description})</span>
                            </>
                        })}
                        {bookingObject?.otherPriceAmount > 0 && <h6 className="mt-2">Full Amount {configs.currencyPrefix}: {bookingObject.amount}</h6>}
                    </>}
                </p>
            </Col>
        </Row>}
        {!isLoadingBookingTicket && _.size(startTimes) === 0 && <Row><Col><Alert>Not available, Check another date</Alert></Col></Row>}
        {discount && <Row>
            <Col>
                <Label className="d-block pb-2">Discount ({configs.currencyPrefix}): {(Number(bookingObject?.amount) - Number(discount.amount))}</Label>
            </Col>
            </Row>}
        </>)
})

const getOtherPricing = (isAdditionalPricingSupport, additionalPricingList, appointmentDate, startTime, endTime, isFullDay) => {
    const formattedStartTime = moment(`${moment(appointmentDate).format('YYYY-MM-DD')} ${startTime}`, 'YYYY-MM-DD HH:mm')
    const formattedEndTime = moment(`${moment(appointmentDate).format('YYYY-MM-DD')} ${endTime}`, 'YYYY-MM-DD HH:mm')
    const isClasWithDates = ((formattedStartTime.hour() * 60 + formattedStartTime.minute()) > (formattedEndTime.hour() * 60 + formattedEndTime.minute()))
    const additionalPricing = _.filter(additionalPricingList, obj => {
        return obj.status === 'Active' && (isClasWithDates ? moment(appointmentDate).format('dddd') === obj.day || moment(appointmentDate).startOf('day').add(1, 'days').format('dddd') === obj.day : moment(appointmentDate).format('dddd') === obj.day)
    });
    const otherPriceArray = [];

    if (isAdditionalPricingSupport && additionalPricing.length > 0) {
        _.forEach(additionalPricing, function(obj) {
            const otherPriceObject = {
                serviceChargeMinutes: 0,
                otherTimeMinutes: 0,
                meta: {}
            }
            if (isFullDay) {
                otherPriceObject.otherTimeMinutes = moment(obj.endTime, 'HH:mm').diff(moment(obj.startTime, 'HH:mm'), 'minutes');
                otherPriceObject.meta = {...obj};
                otherPriceObject.serviceChargeMinutes = otherPriceObject.otherTimeMinutes;

                otherPriceArray.push(otherPriceObject);
            } else {
                const selectedTimeSlotStartTime = `${moment(appointmentDate).format('YYYY-MM-DD')} ${startTime}`;
                const selectedTimeSlotEndTime = `${isClasWithDates ? moment(appointmentDate).startOf('day').add(1, 'days').format('YYYY-MM-DD') : moment(appointmentDate).format('YYYY-MM-DD')} ${endTime}`;
                const otherPriceStartTime = `${isClasWithDates ? moment(appointmentDate).format('dddd') === obj.day ? moment(appointmentDate).format('YYYY-MM-DD') : moment(appointmentDate).startOf('day').add(1, 'days').format('YYYY-MM-DD') : `${moment(appointmentDate).format('YYYY-MM-DD')}`} ${obj.startTime}`               
                const otherPriceEndTime = `${isClasWithDates ? moment(appointmentDate).format('dddd') === obj.day ? moment(appointmentDate).format('YYYY-MM-DD') : moment(appointmentDate).startOf('day').add(1, 'days').format('YYYY-MM-DD') : `${moment(appointmentDate).format('YYYY-MM-DD')}`} ${obj.endTime}`

                const additionalPriceStartTime = moment(selectedTimeSlotStartTime, 'YYYY-MM-DD HH:mm').isBetween(moment(otherPriceStartTime, 'YYYY-MM-DD HH:mm'), moment(otherPriceEndTime, 'YYYY-MM-DD HH:mm'), 'minutes', '[]');
                const additionalPriceEndTime = moment(selectedTimeSlotEndTime, 'YYYY-MM-DD HH:mm').isBetween(moment(otherPriceStartTime, 'YYYY-MM-DD HH:mm'), moment(otherPriceEndTime, 'YYYY-MM-DD HH:mm'), 'minutes', '[]');
                const selectedTimeStart = moment(otherPriceStartTime, 'YYYY-MM-DD HH:mm').isBetween(moment(selectedTimeSlotStartTime, 'YYYY-MM-DD HH:mm'), moment(selectedTimeSlotEndTime, 'YYYY-MM-DD HH:mm'), 'minutes', '[]');
                const selectedTimeEnd = moment(otherPriceEndTime, 'YYYY-MM-DD HH:mm').isBetween(moment(selectedTimeSlotStartTime, 'YYYY-MM-DD HH:mm'), moment(selectedTimeSlotEndTime, 'YYYY-MM-DD HH:mm'), 'minutes', '[]');

                if (additionalPriceEndTime && additionalPriceStartTime) {
                    otherPriceObject.otherTimeMinutes = moment(selectedTimeSlotEndTime, 'YYYY-MM-DD HH:mm').diff(moment(selectedTimeSlotStartTime, 'YYYY-MM-DD HH:mm'), 'minutes');
                }else if (additionalPriceEndTime) {
                    otherPriceObject.otherTimeMinutes = moment(selectedTimeSlotEndTime, 'YYYY-MM-DD HH:mm').diff(moment(otherPriceStartTime, 'YYYY-MM-DD HH:mm'), 'minutes');
                } else if (additionalPriceStartTime) {
                    otherPriceObject.otherTimeMinutes = moment(otherPriceEndTime, 'YYYY-MM-DD HH:mm').diff(moment(selectedTimeSlotStartTime, 'YYYY-MM-DD HH:mm'), 'minutes');
                } else if (selectedTimeStart && selectedTimeEnd) {
                    otherPriceObject.otherTimeMinutes = moment(otherPriceEndTime, 'YYYY-MM-DD HH:mm').diff(moment(otherPriceStartTime, 'YYYY-MM-DD HH:mm'), 'minutes');
                }

                if (otherPriceObject.otherTimeMinutes) {
                    // Math.ceil(durationInMinutes/5) * 5 is a workaround to support additional pricing till mid night
                    // Here, we assume Minimum duration of booking for a sport is 5 mins (which is the current setting)
                    otherPriceObject.otherTimeMinutes = Math.ceil(otherPriceObject.otherTimeMinutes / 5) * 5;
                    const serviceChargeMinutes =  moment(obj.endTime, 'HH:mm').diff(moment(obj.startTime, 'HH:mm'), 'minutes');
                    otherPriceObject.serviceChargeMinutes = Math.ceil(serviceChargeMinutes/ 5) * 5;
                    otherPriceObject.meta = {...obj};
                    otherPriceArray.push(otherPriceObject);
                }
            }
        });

        return otherPriceArray;
    }

    return otherPriceArray;
}

const createStartTimeArray = (bookingDate, shopTimeArr, serviceTime) => {
    const shopDay = _.find(shopTimeArr, {day: moment(bookingDate).format('dddd')}, null)
    const timeArray = []

    if (shopDay) {
        const formattedBookingDate = moment(bookingDate).format('DD/MM/YYYY')
        let openTime = moment(`${formattedBookingDate} ${shopDay.openTime}`, 'DD/MM/YYYY HH:mm')
        const closeTime = moment(`${formattedBookingDate} ${shopDay.closeTime}`, 'DD/MM/YYYY HH:mm')

        if (closeTime.hour() === 23 && closeTime.minute() === 59) {
            closeTime.add( 1, 'minutes')
        }

        let lastTime = closeTime.clone().subtract(serviceTime, 'minutes')

        const nextShopOpeningDate = _.find(shopTimeArr, {day: moment(bookingDate).startOf('day').add(1, 'days').format('dddd')}, null)
        const nextOpenDate = moment(`${moment(bookingDate).startOf('day').add(1, 'days').format('YYYY-MM-DD')} ${nextShopOpeningDate?.openTime}`, 'YYYY-MM-DD HH:mm')
        const nextCloseDate = moment(`${nextOpenDate.format('YYYY-MM-DD')} ${nextShopOpeningDate?.closeTime}`)

        if ((nextCloseDate.hour() * 60 + nextCloseDate.minute()) > 720) {
            nextCloseDate.set({ hour: 12, minute: 0 });
        }

        if (shopDay.isOpenFullDay && nextShopOpeningDate && nextShopOpeningDate.status ==='Active' && nextOpenDate.hour() === 0 && nextOpenDate.minute() === 0) {
            lastTime = nextCloseDate.clone().subtract(serviceTime, 'minutes')
        }


        if (!isTimeSlotExpired(bookingDate, openTime.format('h:mm a'))) {
            timeArray.push(moment(openTime).format('h:mm a'))
        }

        let minutes = openTime.hour() * 60 + openTime.minute()

        while (openTime.isBefore(lastTime) && minutes < 1440) {
            minutes = minutes + TIME_SPLIT_VALUE
            const time = moment(openTime).add(TIME_SPLIT_VALUE, 'minutes').format('h:mm a')

            if (!isTimeSlotExpired(bookingDate, time) && moment(`${moment(bookingDate).format('DD/MM/YYYY')} ${time}`, 'DD/MM/YYYY h:mm a').isSameOrBefore(lastTime) && minutes < 1440) {
                timeArray.push(time)
            }

            openTime = moment(openTime).add(TIME_SPLIT_VALUE, 'minutes');
        }

        return timeArray
    }

    return timeArray
}

const isTimeSlotClash = (TS, TE, RS, RE) => {
    const timeslotStart = moment(`01/01/2024 ${TS}`)
    const timeslotEnd = moment(`01/01/2024 ${TE}`)

    const rangeStart = moment(`01/01/2024 ${RS}`)
    const rangeEnd = moment(`01/01/2024 ${RE}`)

    // If timeslot interval of both are equal
    const case1 = (timeslotStart.format('HH:mm') === rangeStart.format('HH:mm') && timeslotEnd.format('HH:mm') === rangeEnd.format('HH:mm'))

    // If timeslot interval is less than the compared time range
    const case2 = (timeslotStart.isBetween(rangeStart, rangeEnd) || timeslotEnd.isBetween(rangeStart, rangeEnd))

    // If timeslot interval is larger than the compared time range
    const case3 = (rangeStart.isBetween(timeslotStart, timeslotEnd) || rangeEnd.isBetween(timeslotStart, timeslotEnd))

    return case1 || case2 || case3;
}

const creatBookingAreaObject = (area, count, uniqueId) => {
    const object = {displayBookingArea: 'Full Court', halfCourtName: 'FULL', status: 'Active', id: uniqueId ? uniqueId : _.uniqueId()}

    if (area === enumBookingArea.HALF) {
        object.displayBookingArea = `Share Court ${count}`
        object.halfCourtName = `${enumBookingArea.HALF}_${count}`
    }

    return object;
}

const isTimeSlotExpired = (selectedDate, TS) => {

    let currentDate = moment(new Date())

    if (currentDate.isSame(selectedDate, 'day')) {
        let timeslotStart = moment(`${moment(currentDate).format('YYYY/MM/DD')} ${TS}`)

        return timeslotStart.isBefore(currentDate);
    }
}

/**
 * Filters a list of bookings based on the facility ID, booking date, clash date, and time slot overlap.
 *
 * @param {Array} bookings - List of booking objects to filter.
 * @param {string} facilityId - ID of the facility to match bookings against.
 * @param {string} bookingDate - The main date to compare (format: YYYY-MM-DD).
 * @param {string} clashDate - The second date for potential clashes (format: YYYY-MM-DD).
 * @param {string} startTime - The start time of the new booking (format: HH:mm or HH:mm a).
 * @param {string} endTime - The end time of the new booking (format: HH:mm or HH:mm a).
 * @returns {Array} - Filtered list of bookings that match the criteria.
 */
const filterBookingByDateTime = (bookings, facilityId, bookingDate, clashDate, startTime, endTime) => {
    // Format the bookingDate and clashDate to ensure they are in 'YYYY-MM-DD' format
    const formattedBookingDate = moment(bookingDate).format('YYYY-MM-DD');
    let formattedClashDate = moment(clashDate).format('YYYY-MM-DD');

    // Parse the endTime and check if it's in a valid 24-hour format ('HH:mm').
    // If not, assume it's in a 12-hour format ('HH:mm a') and parse accordingly.
    const formattedEndTime = moment(endTime, moment(endTime, 'HH:mm', true).isValid() ? 'HH:mm' : 'HH:mm a');

    // If the end time is exactly midnight (00:00), adjust it to '23:59' to avoid unintended exclusions.
    const refactoredEndTime = formattedEndTime.hour() === 0 && formattedEndTime.minute() === 0 ? '23:59' : endTime;

    const formattedStartTime = moment(startTime, moment(startTime, 'HH:mm', true).isValid() ? 'HH:mm' : 'HH:mm a');

    let isCrossBooking = formattedEndTime.isBefore(formattedStartTime)

    if (refactoredEndTime === '23:59') {
        formattedClashDate = formattedBookingDate
    }

    // Filter the bookings based on the facility ID, date, and time slot overlap
    return   _.filter(bookings, obj => {
        return (
                // Case 1: The booking and clash dates are the same
                (formattedBookingDate === formattedClashDate &&
                    moment(obj.appointmentDate).isSame(moment(formattedBookingDate), 'day') &&
                    obj.facilityId === facilityId)
                ||
                // Case 2: The booking and clash dates are different
                (formattedBookingDate !== formattedClashDate &&
                    moment(obj.appointmentDate).isSame(moment(formattedClashDate), 'day') &&
                    obj.facilityId === facilityId)
            )
            // Ensure the time slots do not overlap using the isTimeSlotClash function
            && (isTimeSlotClash(startTime, refactoredEndTime, obj.startTime, obj.endTime) || (isCrossBooking && (isTimeSlotClash(startTime, '11:59', obj.startTime, obj.endTime) || isTimeSlotClash('00:00', endTime, obj.startTime, obj.endTime))));
    });
};


const mapStateToFacilityProps = (state) => {
    return {
        shopTimeArr: state.shop.shopTimeArr,
        holidays: state.shop.holidays,
        timeOffs: state.shop.timeOffs,
        isLoadingBookingTicket: state.baseComponents.bookingTicketReduxConfig.isLoading,
        shopId: state.shop.shopId,
        isEdit: state.baseComponents.bookingTicketReduxConfig.isEdit,
        editBookingObject: state.baseComponents.bookingTicketReduxConfig.editBookingObject,
        isPickEditBooking: state.baseComponents.bookingTicketReduxConfig.isPickEditBooking,
        serviceTimeOff: state.baseComponents.bookingTicketReduxConfig.serviceTimeOff
    };
};

const SportFacilityTimeSelector = connect(mapStateToFacilityProps, {updateConfigBookingTicketModal}, null, {forwardRef: true})(SportTimer);

export default SportFacilityTimeSelector
